import { createReducer, on } from '@ngrx/store';

import * as fromPersistedStateActions from '../actions/persisted-state.actions';
import * as fromSettingActions from '../actions/setting.actions';

export const titleRepFeatureKey = 'titleRep';

export interface State {
  company: string | null;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  orderTitleCCEnabled: boolean;
  phone: string | null;
  phoneType: string | null;
  photoUrl: string | null;
}

export const initialState: State = {
  company: null,
  email: null,
  firstName: null,
  lastName: null,
  orderTitleCCEnabled: false,
  phone: null,
  phoneType: null,
  photoUrl: null
};

export const reducer = createReducer(
  initialState,
  on(
    fromSettingActions.updateReferralCodeSuccess,
    fromSettingActions.loadSettingsSuccess,
    fromSettingActions.refreshReferralCodeSuccess,
    fromPersistedStateActions.migratePersistedOldStateReferralCodeSuccess,
    (state, { payload }) => ({
      ...state,
      company: payload.data.organization.name,
      email: payload.data.titleRep.email ?? payload.data.office.email,
      firstName: payload.data.titleRep.firstName,
      lastName: payload.data.titleRep.lastName,
      orderTitleCCEnabled: payload.data.titleRep.copyRepOnOrderTitle,
      phone: payload.data.titleRep.phone ?? payload.data.office.phone,
      phoneType: payload.data.titleRep.phone ? payload.data.titleRep.primaryPhoneType : 'office',
      photoUrl: payload.data.titleRep.photoUrl
    })
  ),
  on(fromPersistedStateActions.loadPersistedStateFailure, fromPersistedStateActions.persistedStateReset, () => ({
    ...initialState
  })),
  on(fromPersistedStateActions.loadPersistedStateSuccess, (state, { payload }) => ({
    ...state,
    ...payload[titleRepFeatureKey]
  }))
);
